import { render, staticRenderFns } from "./EffectsModule.vue?vue&type=template&id=148e6b8a&scoped=true"
import script from "./EffectsModule.vue?vue&type=script&lang=js"
export * from "./EffectsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e6b8a",
  null
  
)

export default component.exports